import { Injectable } from "@angular/core";
import { AppConfigService } from './appConfig.service';

@Injectable()
export class BauCuaService {
    constructor(private configService: AppConfigService) { }
    initBC1s(data = {}, nav: any) {
        data["flag"] = 'baucua1sInit';
        return this.configService.initBC1s(data, nav);
    }

    getBalanceMain(data = {}, nav: any) {
        data["flag"] = 'balance';
        return this.configService.getBalanceMain(data, nav);
    }

    bettingBC1s(data = {}, nav: any) {
        return this.configService.bettingBC1s(data, nav);
    }

    initBC1m(data = {}, nav: any) {
        data["flag"] = 'baucua1mInit';
        return this.configService.initBC1m(data, nav);
    }
    getHistoryIssues(data = {}, nav: any) {
        return this.configService.getHistoryIssues(data, nav);
    }
    getCurIssueNext(data = {}, nav: any) {
        data['flag'] = 'baucua1mCurIssue';
        return this.configService.getCurIssueNext(data, nav);
    }
    getOpenWin(data = {}, nav: any) {
        data['flag'] = 'baucua1mBetOpenWin';
        return this.configService.getOpenWin(data, nav);
    }
    bettingBC1M(data = {}, nav: any) {
        data['flag'] = 'baucua1mBet';
        return this.configService.bettingBC1M(data, nav);
    }
}


// WEBPACK FOOTER //
// ./src/services/baucua.service.ts